export default {
  Cancelled: 'Cancelled',
};
